module.exports = __webpack_public_path__ + "img/page_34.395e315c.png";